import type { EmblaCarouselType } from 'embla-carousel';
// ⚠️ 값이 아니라 **타입만** 들여온다 — 이 한 줄이 `embla-carousel` 쪽 선언 병합
//    (`EmblaPluginsType.autoScroll` · `autoScroll:play`/`autoScroll:stop` 이벤트)을 함께 끌어온다.
import type { AutoScrollType } from 'embla-carousel-auto-scroll';

import { useState, useEffect, useCallback } from 'react';

// ----------------------------------------------------------------------

export function useCarouselAutoScroll(mainApi?: EmblaCarouselType) {
  const [isPlaying, setIsPlaying] = useState(false);

  const onClickAutoplay = useCallback(
    (callback: () => void) => {
      const autoScroll = mainApi?.plugins()?.autoScroll as AutoScrollType | undefined;
      if (!autoScroll) return;

      const resetOrStop =
        autoScroll.options.stopOnInteraction === false ? autoScroll.reset : autoScroll.stop;

      resetOrStop();
      callback();
    },
    [mainApi]
  );

  const onTogglePlay = useCallback(() => {
    const autoScroll = mainApi?.plugins()?.autoScroll as AutoScrollType | undefined;
    if (!autoScroll) return;

    const playOrStop = autoScroll.isPlaying() ? autoScroll.stop : autoScroll.play;
    playOrStop();
  }, [mainApi]);

  useEffect(() => {
    const autoScroll = mainApi?.plugins()?.autoScroll as AutoScrollType | undefined;
    if (!autoScroll) return;

    setIsPlaying(autoScroll.isPlaying());
    // `autoScroll` 이 있으면 `mainApi` 도 있다 — 좁히기가 옵셔널 체인을 넘어오지 못해 `!` 로만 알린다
    mainApi!
      .on('autoScroll:play', () => setIsPlaying(true))
      .on('autoScroll:stop', () => setIsPlaying(false))
      .on('reInit', () => setIsPlaying(false));
  }, [mainApi]);

  return { isPlaying, onTogglePlay, onClickAutoplay };
}
